import { noOpFunction } from 'lib/noOpFunction';
/**
 * Stub
 * @see native version of this file
 */
export const useInitialNotificationEvent = noOpFunction;
